import { atom } from "recoil";
import { GoogleAutocompleteAddressProps } from "../../components/google-autocomplete/google-autocomplete-props";
export const personalGoogleAutocompleteState =
  atom<GoogleAutocompleteAddressProps | null>({
    key: "personalGoogleAutocompleteState",
    default: null,
  });
